import React from 'react';
import { I18n } from 'react-redux-i18n';
import {
  Edit01,
  Flag06,
  Hand,
  Image01,
  Image03,
  LayersTwo01,
  Link01,
  PlusCircle,
  RefreshCw01,
  Type01,
  UploadCloud01,
  Users01,
} from '@untitledui/icons';

import { TriggerReason } from '../../models';
import { getTriggerIconMeta } from '../../helpers/triggerIcon';
import styles from './TriggerBadge.module.css';

export interface TriggerBadgeProps {
  trigger: TriggerReason;
  testId?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ICONS: Record<string, React.ComponentType<any>> = {
  PlusCircle,
  Type01,
  FileEdit: Edit01,
  Image01,
  Image03,
  Link01,
  Users01,
  Hand,
  RefreshCw01,
  UploadCloud01,
  LayersTwo01,
};

export function TriggerBadge({ trigger, testId }: TriggerBadgeProps): React.ReactElement {
  const meta = getTriggerIconMeta(trigger);
  const Icon = ICONS[meta.iconName] ?? Flag06;
  const style: React.CSSProperties = { '--badge-tone-color': meta.toneColorVar } as React.CSSProperties;
  return (
    <span className={styles.badge} style={style} data-testid={testId} data-trigger={trigger}>
      <span className={styles.iconWrap} aria-hidden="true">
        <Icon width={14} height={14} />
      </span>
      <span>{I18n.t(meta.labelI18nKey)}</span>
    </span>
  );
}

export default TriggerBadge;
